import { Property } from '../types';

const BASE_URL = '/api/properties/admin';

export async function get183150PropertiesPaginatedApi(
  offset = 0,
  limit = 100,
  filters?: { status?: string; owner?: string; search?: string; brpCode?: string; propertyCode?: string }
): Promise<{ items: Property[]; total: number; hasMore: boolean; offset: number; limit: number }> {
  const params = new URLSearchParams({
    offset: String(offset),
    limit: String(limit),
    ...(filters?.status ? { status: filters.status } : {}),
    ...(filters?.owner ? { owner: filters.owner } : {}),
    ...(filters?.search ? { search: filters.search } : {}),
    ...(filters?.brpCode ? { brpCode: filters.brpCode } : {}),
    ...(filters?.propertyCode ? { propertyCode: filters.propertyCode } : {}),
  });
  const res = await fetch(`${BASE_URL}/183150?${params.toString()}`);
  const data = await res.json();
  if (!data.success) throw new Error(data.message || 'Error al obtener inmuebles 183150');
  return data;
}

export async function getAllActivePropertiesApi(): Promise<Property[]> {
  const res = await fetch(`${BASE_URL}/all-active`);
  const data = await res.json();
  if (!data.success) throw new Error(data.message || 'Error al obtener inmuebles activos');
  return data.items || [];
}

export async function get183150ActivePropertiesApi(): Promise<Property[]> {
  const res = await fetch(`${BASE_URL}/183150-active`);
  const data = await res.json();
  if (!data.success) throw new Error(data.message || 'Error al obtener inventario activo 183150');
  return data.items || [];
}

export async function getPropertiesByLocationApi(city: string, locality: string): Promise<Property[]> {
  const params = new URLSearchParams({ city, locality });
  const res = await fetch(`${BASE_URL}/by-location?${params.toString()}`);
  const data = await res.json();
  if (!data.success) throw new Error(data.message || 'Error al obtener inmuebles por ubicación');
  return data.items || [];
}

export async function savePropertyApi(id: string, propertyData: Partial<Property>): Promise<void> {
  const res = await fetch(`${BASE_URL}/save`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id, propertyData }),
  });
  const data = await res.json();
  if (!data.success) throw new Error(data.message || 'Error al guardar el inmueble');
}

export async function createPropertyApi(propertyData: Partial<Property>, customId?: string): Promise<{ id: string }> {
  const res = await fetch(`${BASE_URL}/create`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ propertyData, customId }),
  });
  const data = await res.json();
  if (!data.success) throw new Error(data.message || 'Error al crear el inmueble');
  return { id: data.id };
}

export async function softDeletePropertyApi(id: string): Promise<void> {
  const res = await fetch(`${BASE_URL}/soft-delete`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id }),
  });
  const data = await res.json();
  if (!data.success) throw new Error(data.message || 'Error al desactivar el inmueble');
}

export async function batchUpsertPropertiesApi(items: Array<{ id?: string; data: Record<string, any> }>, merge = true): Promise<number> {
  const res = await fetch(`${BASE_URL}/batch-upsert`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items, merge }),
  });
  const data = await res.json();
  if (!data.success) throw new Error(data.message || 'Error al procesar lote');
  return data.processedCount || 0;
}
